export default __webpack_public_path__ + "static/media/arctic-x-logo.e5bbfdd9.png";